// extracted by mini-css-extract-plugin
export default {"container":"Product_container__Nk0ii","products":"Product_products__0ci5R","menu":"Product_menu__nMcHs","list":"Product_list__T9F3s","product":"Product_product__hQeO1"};